import { render, staticRenderFns } from "./SelectCourierInter.vue?vue&type=template&id=400cedca&scoped=true&"
import script from "./SelectCourierInter.vue?vue&type=script&lang=js&"
export * from "./SelectCourierInter.vue?vue&type=script&lang=js&"
import style0 from "./SelectCourierInter.vue?vue&type=style&index=0&id=400cedca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400cedca",
  null
  
)

export default component.exports